import { SILK_ROAD_REGIONS } from './silkRoadRegions';

const LANDMARK_IMAGES = {
  uzbekistan: [
    'https://images.pexels.com/photos/19439206/pexels-photo-19439206.jpeg?auto=compress&cs=tinysrgb&w=600',
    'https://images.unsplash.com/photo-1653023102302-247f5f0fbdd1?w=600&q=80',
    'https://images.pexels.com/photos/35375769/pexels-photo-35375769.jpeg?auto=compress&cs=tinysrgb&w=600',
  ],
  kazakhstan: [
    'https://images.pexels.com/photos/12604140/pexels-photo-12604140.png?auto=compress&cs=tinysrgb&w=600',
    'https://images.pexels.com/photos/27706764/pexels-photo-27706764.jpeg?auto=compress&cs=tinysrgb&w=600',
    'https://images.pexels.com/photos/15792410/pexels-photo-15792410.jpeg?auto=compress&cs=tinysrgb&w=600',
  ],
  kyrgyzstan: [
    'https://images.unsplash.com/photo-1626767507695-7165523a5372?w=600&q=80',
    'https://images.pexels.com/photos/12702443/pexels-photo-12702443.jpeg?auto=compress&cs=tinysrgb&w=600',
    'https://images.pexels.com/photos/17533368/pexels-photo-17533368.jpeg?auto=compress&cs=tinysrgb&w=600',
  ],
  tajikistan: [
    'https://images.unsplash.com/photo-1590999563469-effba37954b2?w=600&q=80',
    'https://images.unsplash.com/photo-1726547507025-b93372d892ad?w=600&q=80',
    'https://images.pexels.com/photos/19805419/pexels-photo-19805419.jpeg?auto=compress&cs=tinysrgb&w=600',
  ],
  caucasus: [
    'https://images.unsplash.com/photo-1594766722982-fb4cd139ee7c?w=600&q=80',
    'https://images.unsplash.com/photo-1764421225836-38ee86679e00?w=600&q=80',
    'https://images.unsplash.com/photo-1642888649086-1c4745c4a7f2?w=600&q=80',
  ],
  iran: [
    'https://images.unsplash.com/photo-1635645038071-def883e40945?w=600&q=80',
    'https://images.unsplash.com/photo-1758915464828-11992062683b?w=600&q=80',
    'https://images.pexels.com/photos/30674138/pexels-photo-30674138.jpeg?auto=compress&cs=tinysrgb&w=600',
  ],
  turkey: [
    'https://images.pexels.com/photos/17565155/pexels-photo-17565155.jpeg?auto=compress&cs=tinysrgb&w=600',
    'https://images.unsplash.com/photo-1715960202093-89e5456d36d0?w=600&q=80',
    'https://images.pexels.com/photos/20697149/pexels-photo-20697149.jpeg?auto=compress&cs=tinysrgb&w=600',
  ],
};

export const getLandmarkImages = (slug) => LANDMARK_IMAGES[slug] || [];
